import { format } from 'date-fns-tz'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { currentTzDate } from 'Data/format.js'

export function isToday(date, timeZoneId) {
  return (
    format(currentTzDate(timeZoneId), 'yyyy-MM-dd') ===
    format(date, 'yyyy-MM-dd')
  )
}

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'tab',
  })
  let time_zone_id = useDataValue({
    context: 'tab',
    viewPath: props.viewPath,
    path: 'selected.time_zone_id',
  })

  return function onClick() {
    submit({ type: 'setDate', date: currentTzDate(time_zone_id) })
  }
}
